<template>
  <div class="case-detail">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link" style="color: #3498db;">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="container">
        <router-link to="/">首页</router-link>
        <span class="separator">></span>
        <router-link to="/news">成功案例</router-link>
        <span class="separator">></span>
        <span class="current">案例详情</span>
      </div>
    </div>

    <!-- 案例内容 -->
    <main class="case-content">
      <div class="container">
        <!-- 案例头部 -->
        <header class="case-header">
          <div class="case-hero">
            <div class="case-image">
              <div class="image-placeholder">🏆</div>
            </div>
            <div class="case-info">
              <h1 class="case-title">{{ caseStudy.title }}</h1>
              <div class="case-meta">
                <span class="category">{{ caseStudy.category }}</span>
                <span class="date">{{ caseStudy.date }}</span>
                <span class="client">客户：{{ caseStudy.client }}</span>
              </div>
              <p class="case-summary">{{ caseStudy.summary }}</p>
              <div class="case-tags">
                <span class="tag" v-for="tag in caseStudy.tags" :key="tag">{{ tag }}</span>
              </div>
            </div>
          </div>
        </header>

        <!-- 案例详情 -->
        <section class="case-details">
          <!-- 项目背景 -->
          <div class="detail-section">
            <h2>项目背景</h2>
            <div class="section-content">
              <p>{{ caseStudy.background }}</p>
              <div class="background-stats">
                <div class="stat-item">
                  <div class="stat-number">{{ caseStudy.stats && caseStudy.stats.age ? caseStudy.stats.age:'' }}</div>
                  <div class="stat-label">年龄</div>
                </div>
                <div class="stat-item">
                  <div class="stat-number">{{ caseStudy.stats && caseStudy.stats.duration ? caseStudy.stats.duration:'' }}</div>
                  <div class="stat-label">健康问题持续</div>
                </div>
                <div class="stat-item">
                  <div class="stat-number">{{ caseStudy.stats && caseStudy.stats.duration ? caseStudy.stats.previous:'' }}</div>
                  <div class="stat-label">之前尝试方法</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 挑战与问题 -->
          <div class="detail-section">
            <h2>挑战与问题</h2>
            <div class="section-content">
              <div class="challenges-grid">
                <div v-for="challenge in caseStudy.challenges" :key="challenge.id" class="challenge-card">
                  <div class="challenge-icon">{{ challenge.icon }}</div>
                  <h3>{{ challenge.title }}</h3>
                  <p>{{ challenge.description }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 解决方案 -->
          <div class="detail-section">
            <h2>解决方案</h2>
            <div class="section-content">
              <div class="solution-timeline">
                <div v-for="step in caseStudy.solution" :key="step.id" class="timeline-item">
                  <div class="timeline-marker">{{ step.step }}</div>
                  <div class="timeline-content">
                    <h3>{{ step.title }}</h3>
                    <p>{{ step.description }}</p>
                    <div class="timeline-details">
                      <span class="duration">{{ step.duration }}</span>
                      <span class="method">{{ step.method }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 实施过程 -->
          <div class="detail-section">
            <h2>实施过程</h2>
            <div class="section-content">
              <div class="implementation-grid">
                <div v-for="phase in caseStudy.implementation" :key="phase.id" class="phase-card">
                  <div class="phase-header">
                    <span class="phase-number">{{ phase.phase }}</span>
                    <h3>{{ phase.title }}</h3>
                  </div>
                  <div class="phase-content">
                    <p>{{ phase.description }}</p>
                    <ul class="phase-tasks">
                      <li v-for="task in phase.tasks" :key="task">{{ task }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 成果展示 -->
          <div class="detail-section">
            <h2>成果展示</h2>
            <div class="section-content">
              <div class="results-overview">
                <div class="result-metrics" v-if="caseStudy.results && caseStudy.results.metrics">
                  <div v-for="metric in caseStudy.results.metrics" :key="metric.name" class="metric-card">
                    <div class="metric-value">{{ metric.value }}</div>
                    <div class="metric-name">{{ metric.name }}</div>
                    <div class="metric-change" :class="metric.changeType">
                      {{ metric.change }}
                    </div>
                  </div>
                </div>
                
                <div class="result-chart" v-if="caseStudy.results && caseStudy.results.chart">
                  <h3>改善趋势图</h3>
                  <div class="chart-placeholder">
                    <div class="chart-bars">
                      <div v-for="(bar, index) in caseStudy.results.chart" :key="index" class="chart-bar">
                        <div class="bar" :style="{ height: bar.height + '%' }"></div>
                        <span class="bar-label">{{ bar.label }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 客户反馈 -->
              <div class="client-testimonial"  v-if="caseStudy.results && caseStudy.results.testimonial">
                <div class="testimonial-content">
                  <div class="quote-icon">💬</div>
                  <blockquote>{{ caseStudy.results.testimonial.quote }}</blockquote>
                  <div class="testimonial-author">
                    <div class="author-avatar">{{ caseStudy.results.testimonial.avatar }}</div>
                    <div class="author-info">
                      <div class="author-name">{{ caseStudy.results.testimonial.name }}</div>
                      <div class="author-title">{{ caseStudy.results.testimonial.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 技术亮点 -->
          <div class="detail-section">
            <h2>技术亮点</h2>
            <div class="section-content">
              <div class="tech-features">
                <div v-for="feature in caseStudy.techFeatures" :key="feature.id" class="tech-feature">
                  <div class="feature-icon">{{ feature.icon }}</div>
                  <div class="feature-content">
                    <h3>{{ feature.title }}</h3>
                    <p>{{ feature.description }}</p>
                    <div class="feature-benefits">
                      <span v-for="benefit in feature.benefits" :key="benefit" class="benefit-tag">
                        {{ benefit }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 经验总结 -->
          <div class="detail-section">
            <h2>经验总结</h2>
            <div class="section-content">
              <div class="lessons-grid">
                <div v-for="lesson in caseStudy.lessons" :key="lesson.id" class="lesson-card">
                  <div class="lesson-icon">{{ lesson.icon }}</div>
                  <h3>{{ lesson.title }}</h3>
                  <p>{{ lesson.content }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- 相关案例 -->
        <section class="related-cases">
          <h2>相关案例</h2>
          <div class="cases-grid">
            <article 
              v-for="related in relatedCases" 
              :key="related.id"
              class="case-card"
              @click="viewCase(related)"
            >
              <div class="case-card-image">
                <div class="image-placeholder">{{ related.image }}</div>
              </div>
              <div class="case-card-content">
                <h3>{{ related.title }}</h3>
                <p class="case-summary">{{ related.summary }}</p>
                <div class="case-meta">
                  <span class="case-category">{{ related.category }}</span>
                  <span class="case-date">{{ related.date }}</span>
                </div>
              </div>
            </article>
          </div>
        </section>

        <!-- 咨询表单 -->
        <section class="consultation-section">
          <div class="consultation-content">
            <h2>获得同样的健康改善</h2>
            <p>如果您也面临类似的健康问题，欢迎联系我们，我们的专家团队将为您提供个性化的健康解决方案。</p>
            
            <form @submit.prevent="submitConsultation" class="consultation-form">
              <div class="form-row">
                <div class="form-group">
                  <label>姓名</label>
                  <input type="text" v-model="consultationForm.name" placeholder="请输入您的姓名" required>
                </div>
                <div class="form-group">
                  <label>电话</label>
                  <input type="tel" v-model="consultationForm.phone" placeholder="请输入您的电话" required>
                </div>
              </div>
              <div class="form-group">
                <label>邮箱</label>
                <input type="email" v-model="consultationForm.email" placeholder="请输入您的邮箱">
              </div>
              <div class="form-group">
                <label>健康问题描述</label>
                <textarea 
                  v-model="consultationForm.issue" 
                  placeholder="请简要描述您的健康问题..." 
                  rows="4"
                  required
                ></textarea>
              </div>
              <button type="submit" class="btn-submit">预约咨询</button>
            </form>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'CaseDetail',
  data() {
    return {
      currentCaseId: 1,
      allCases: {
        1: {
          id: 1,
          title: '慢性疲劳综合征患者的量子健康调理成功案例',
          category: '慢性病调理',
          date: '2024-03-15',
          client: '张女士',
          summary: '通过量子健康检测和个性化调理方案，成功帮助一位长期受慢性疲劳综合征困扰的患者恢复健康活力，重获生活质量。',
          tags: ['慢性疲劳', '量子调理', '个性化方案', '成功康复'],
          background: '张女士，42岁，企业高管，长期受慢性疲劳综合征困扰超过3年。主要症状包括持续性疲劳、睡眠质量差、注意力不集中、免疫力低下等。此前尝试过多种传统治疗方法，效果均不理想，严重影响了工作和生活质量。',
          stats: {
            age: '42岁',
            duration: '3年+',
            previous: '8种'
          },
          challenges: [
            {
              id: 1,
              icon: '😴',
              title: '严重睡眠障碍',
              description: '入睡困难，夜间易醒，睡眠质量极差，白天精神不振'
            },
            {
              id: 2,
              icon: '🔋',
              title: '持续性疲劳',
              description: '即使充分休息也无法缓解疲劳感，影响日常工作和生活'
            },
            {
              id: 3,
              icon: '🧠',
              title: '认知功能下降',
              description: '注意力不集中，记忆力减退，工作效率明显降低'
            },
            {
              id: 4,
              icon: '🛡️',
              title: '免疫力低下',
              description: '容易感冒，恢复缓慢，身体抵抗力明显下降'
            }
          ],
          solution: [
            {
              id: 1,
              step: '01',
              title: '量子健康检测',
              description: '采用先进的量子检测技术，全面评估患者的身体健康状况，包括细胞能量水平、神经系统功能、内分泌状态等关键指标。',
              duration: '2小时',
              method: '量子共振检测'
            },
            {
              id: 2,
              step: '02',
              title: '个性化方案制定',
              description: '基于检测结果，制定针对性的调理方案，包括营养补充、作息调整、运动指导、心理调节等综合措施。',
              duration: '1周',
              method: '多学科会诊'
            },
            {
              id: 3,
              step: '03',
              title: '量子能量调理',
              description: '运用量子能量调理技术，平衡身体能量场，激活细胞活力，促进身体自我修复能力。',
              duration: '8周',
              method: '量子能量场调理'
            },
            {
              id: 4,
              step: '04',
              title: '持续跟踪调整',
              description: '定期进行健康评估，根据身体变化及时调整调理方案，确保最佳效果。',
              duration: '持续进行',
              method: '动态监测'
            }
          ],
          implementation: [
            {
              id: 1,
              phase: '第一阶段',
              title: '基础调理期（1-2周）',
              description: '建立健康基础，改善睡眠质量，提升基础能量水平。',
              tasks: [
                '调整作息时间，建立规律睡眠',
                '营养补充，改善细胞营养状态',
                '基础能量调理，提升身体活力'
              ]
            },
            {
              id: 2,
              phase: '第二阶段',
              title: '深度调理期（3-6周）',
              description: '深入调理身体机能，修复受损系统，提升整体健康水平。',
              tasks: [
                '量子能量场深度调理',
                '内分泌系统平衡调节',
                '神经系统功能优化'
              ]
            },
            {
              id: 3,
              phase: '第三阶段',
              title: '巩固提升期（7-8周）',
              description: '巩固调理效果，建立健康生活方式，预防复发。',
              tasks: [
                '效果巩固调理',
                '健康生活方式指导',
                '长期健康管理计划制定'
              ]
            }
          ],
          results: {
            metrics: [
              {
                name: '睡眠质量',
                value: '92%',
                change: '+65%',
                changeType: 'positive'
              },
              {
                name: '精力水平',
                value: '88%',
                change: '+72%',
                changeType: 'positive'
              },
              {
                name: '工作效率',
                value: '85%',
                change: '+58%',
                changeType: 'positive'
              },
              {
                name: '免疫力',
                value: '90%',
                change: '+45%',
                changeType: 'positive'
              }
            ],
            chart: [
              { label: '调理前', height: 25 },
              { label: '2周', height: 40 },
              { label: '4周', height: 60 },
              { label: '6周', height: 75 },
              { label: '8周', height: 90 }
            ],
            testimonial: {
              quote: '量子健康调理彻底改变了我的生活。经过8周的专业调理，我不仅摆脱了长期困扰的疲劳问题，更重要的是重新找回了生活的热情和工作的动力。感谢和合网链的专业团队！',
              name: '张女士',
              title: '企业高管',
              avatar: '👩‍💼'
            }
          },
          techFeatures: [
            {
              id: 1,
              icon: '⚡',
              title: '量子能量检测',
              description: '利用量子共振原理，精准检测身体各系统的能量状态和功能水平。',
              benefits: ['无创检测', '精准度高', '全面评估']
            },
            {
              id: 2,
              icon: '🎯',
              title: '个性化方案',
              description: '根据检测结果和个人体质，制定针对性的健康调理方案。',
              benefits: ['量身定制', '科学配比', '动态调整']
            },
            {
              id: 3,
              icon: '🔄',
              title: '能量场调理',
              description: '通过量子能量场技术，平衡身体能量，激活自我修复能力。',
              benefits: ['深层调理', '根本改善', '持久效果']
            }
          ],
          lessons: [
            {
              id: 1,
              icon: '🎯',
              title: '精准诊断是关键',
              content: '传统的症状描述往往无法找到问题的根源，量子健康检测能够深入细胞层面，发现潜在的健康问题，为制定有效方案提供科学依据。'
            },
            {
              id: 2,
              icon: '⏰',
              title: '耐心等待效果',
              content: '健康调理是一个循序渐进的过程，需要患者有足够的耐心和信心，配合专业方案进行持续调理。'
            },
            {
              id: 3,
              icon: '🤝',
              title: '医患配合很重要',
              content: '成功案例的背后是医患双方的密切配合，患者严格按照方案执行，医生根据反馈及时调整，共同达到理想效果。'
            }
          ]
        },
        2: {
          id: 2,
          title: '量子能量疗法改善失眠症状的临床案例',
          category: '量子调理',
          date: '2024-03-10',
          client: '李先生',
          summary: '运用量子能量调理技术，结合个性化作息指导，帮助严重失眠患者恢复正常睡眠模式，提升生活质量。',
          tags: ['失眠治疗', '量子能量', '睡眠改善', '无创疗法'],
          background: '李先生，38岁，IT从业者，长期受严重失眠困扰超过5年。主要症状包括入睡困难、夜间易醒、早醒、白天精神不振等。长期依赖安眠药物，但效果逐渐减弱，且出现副作用。',
          stats: {
            age: '38岁',
            duration: '5年+',
            previous: '多种安眠药'
          },
          challenges: [
            {
              id: 1,
              icon: '😴',
              title: '入睡困难',
              description: '躺在床上超过2小时才能入睡，精神紧张焦虑'
            },
            {
              id: 2,
              icon: '⏰',
              title: '睡眠浅易醒',
              description: '夜间醒来3-4次，每次醒后难以再次入睡'
            },
            {
              id: 3,
              icon: '💊',
              title: '药物依赖',
              description: '长期服用安眠药，产生依赖性和耐药性'
            },
            {
              id: 4,
              icon: '😔',
              title: '日间功能障碍',
              description: '白天注意力不集中，记忆力下降，工作效率低'
            }
          ],
          solution: [
            {
              id: 1,
              step: '01',
              title: '睡眠质量评估',
              description: '通过量子检测技术评估神经系统功能，分析睡眠障碍的根本原因。',
              duration: '1.5小时',
              method: '量子睡眠检测'
            },
            {
              id: 2,
              step: '02',
              title: '药物减量计划',
              description: '制定科学的药物减量方案，逐步减少对安眠药的依赖。',
              duration: '2周',
              method: '渐进减量法'
            },
            {
              id: 3,
              step: '03',
              title: '量子神经调理',
              description: '运用量子能量技术调理神经系统，恢复自然的睡眠-觉醒节律。',
              duration: '6周',
              method: '量子神经调节'
            },
            {
              id: 4,
              step: '04',
              title: '睡眠行为训练',
              description: '结合认知行为疗法，建立健康的睡眠习惯和行为模式。',
              duration: '持续进行',
              method: 'CBT-I疗法'
            }
          ],
          implementation: [
            {
              id: 1,
              phase: '第一阶段',
              title: '药物减量期（1-2周）',
              description: '逐步减少安眠药剂量，配合量子调理缓解戒断症状。',
              tasks: [
                '制定个性化减药计划',
                '量子能量调理缓解焦虑',
                '建立放松训练技巧'
              ]
            },
            {
              id: 2,
              phase: '第二阶段',
              title: '神经调节期（3-6周）',
              description: '重点调理神经系统功能，重建自然睡眠节律。',
              tasks: [
                '量子神经节律调节',
                '睡眠环境优化指导',
                '放松技术训练'
              ]
            },
            {
              id: 3,
              phase: '第三阶段',
              title: '巩固期（7-8周）',
              description: '巩固治疗效果，建立长期健康睡眠模式。',
              tasks: [
                '睡眠习惯强化训练',
                '定期效果评估',
                '预防复发指导'
              ]
            }
          ],
          results: {
            metrics: [
              {
                name: '入睡时间',
                value: '15分钟',
                change: '-85%',
                changeType: 'positive'
              },
              {
                name: '睡眠时长',
                value: '7.5小时',
                change: '+50%',
                changeType: 'positive'
              },
              {
                name: '夜醒次数',
                value: '0-1次',
                change: '-75%',
                changeType: 'positive'
              },
              {
                name: '日间精力',
                value: '90%',
                change: '+80%',
                changeType: 'positive'
              }
            ],
            chart: [
              { label: '治疗前', height: 20 },
              { label: '2周', height: 35 },
              { label: '4周', height: 55 },
              { label: '6周', height: 75 },
              { label: '8周', height: 90 }
            ],
            testimonial: {
              quote: '经过8周的量子调理治疗，我终于摆脱了长达5年的失眠困扰。现在不需要药物也能自然入睡，白天的精神状态完全不同了。感谢和合网链给了我重获健康睡眠的机会！',
              name: '李先生',
              title: 'IT工程师',
              avatar: '👨‍💻'
            }
          },
          techFeatures: [
            {
              id: 1,
              icon: '🧠',
              title: '神经节律调节',
              description: '通过量子技术调节大脑神经节律，恢复自然的睡眠-觉醒周期。',
              benefits: ['无创安全', '精准调节', '持久效果']
            },
            {
              id: 2,
              icon: '🌙',
              title: '睡眠质量监测',
              description: '实时监测睡眠各阶段质量，为调理方案提供科学依据。',
              benefits: ['实时监测', '数据分析', '方案优化']
            },
            {
              id: 3,
              icon: '🎯',
              title: '个性化治疗',
              description: '根据个体差异制定专属治疗方案，确保最佳治疗效果。',
              benefits: ['量身定制', '精准施治', '动态调整']
            }
          ],
          lessons: [
            {
              id: 1,
              icon: '🎯',
              title: '综合治疗更重要',
              content: '失眠问题往往涉及多方面因素，单一治疗效果有限，综合运用多种技术手段才能取得理想效果。'
            },
            {
              id: 2,
              icon: '⏰',
              title: '循序渐进是关键',
              content: '睡眠问题的改善需要循序渐进，急于求成往往适得其反，耐心配合治疗才能获得长期效果。'
            },
            {
              id: 3,
              icon: '🤝',
              title: '患者配合度决定成败',
              content: '睡眠治疗的成功很大程度上取决于患者的配合程度，严格按照指导执行是治疗成功的关键。'
            }
          ]
        },
        3: {
          id: 3,
          title: '高血压患者的综合健康管理方案',
          category: '健康管理',
          date: '2024-03-05',
          client: '王先生',
          summary: '通过健康检测、营养指导、运动处方等综合干预，帮助高血压患者稳定血压，减少药物依赖。',
          tags: ['高血压', '健康管理', '生活方式', '血压控制'],
          background: '王先生，52岁，企业中层管理者，高血压病史8年。长期服用降压药物，但血压控制不稳定，时有波动。工作压力大，生活不规律，缺乏运动，饮食偏咸。',
          stats: {
            age: '52岁',
            duration: '8年',
            previous: '多种降压药'
          },
          challenges: [
            {
              id: 1,
              icon: '💉',
              title: '血压波动大',
              description: '血压不稳定，受情绪和作息影响明显'
            },
            {
              id: 2,
              icon: '💊',
              title: '药物副作用',
              description: '长期服药出现头晕、乏力等副作用'
            },
            {
              id: 3,
              icon: '🍔',
              title: '不良生活习惯',
              description: '饮食偏咸，缺乏运动，作息不规律'
            },
            {
              id: 4,
              icon: '😰',
              title: '工作压力大',
              description: '工作繁忙，精神紧张，影响血压控制'
            }
          ],
          solution: [
            {
              id: 1,
              step: '01',
              title: '全面健康评估',
              description: '通过量子检测技术全面评估心血管系统功能，分析血压波动的根本原因。',
              duration: '2小时',
              method: '量子血管检测'
            },
            {
              id: 2,
              step: '02',
              title: '个性化干预方案',
              description: '制定包括营养、运动、心理调节在内的综合干预方案。',
              duration: '1周',
              method: '多学科会诊'
            },
            {
              id: 3,
              step: '03',
              title: '量子血管调理',
              description: '运用量子能量技术调理血管弹性，改善血液循环功能。',
              duration: '12周',
              method: '量子血管调理'
            },
            {
              id: 4,
              step: '04',
              title: '生活方式重塑',
              description: '指导建立健康的生活习惯，包括饮食、运动、作息等。',
              duration: '持续进行',
              method: '健康管理'
            }
          ],
          implementation: [
            {
              id: 1,
              phase: '第一阶段',
              title: '基础调理期（1-4周）',
              description: '建立健康基础，改善生活习惯，稳定血压水平。',
              tasks: [
                '低盐饮食指导',
                '有氧运动训练',
                '作息时间调整'
              ]
            },
            {
              id: 2,
              phase: '第二阶段',
              title: '深度调理期（5-8周）',
              description: '深入调理心血管功能，减少药物依赖。',
              tasks: [
                '量子血管弹性调理',
                '药物剂量调整',
                '压力管理训练'
              ]
            },
            {
              id: 3,
              phase: '第三阶段',
              title: '巩固期（9-12周）',
              description: '巩固治疗效果，建立长期健康管理模式。',
              tasks: [
                '效果巩固调理',
                '长期健康计划制定',
                '预防复发指导'
              ]
            }
          ],
          results: {
            metrics: [
              {
                name: '收缩压',
                value: '125mmHg',
                change: '-15%',
                changeType: 'positive'
              },
              {
                name: '舒张压',
                value: '82mmHg',
                change: '-12%',
                changeType: 'positive'
              },
              {
                name: '药物剂量',
                value: '减少50%',
                change: '-50%',
                changeType: 'positive'
              },
              {
                name: '生活质量',
                value: '显著改善',
                change: '+60%',
                changeType: 'positive'
              }
            ],
            chart: [
              { label: '治疗前', height: 30 },
              { label: '4周', height: 45 },
              { label: '8周', height: 65 },
              { label: '12周', height: 85 }
            ],
            testimonial: {
              quote: '经过12周的综合健康管理，我的血压终于稳定了，药物也减了一半。更重要的是，我学会了如何健康生活，整个人都轻松了很多。感谢和合网链的专业指导！',
              name: '王先生',
              title: '企业经理',
              avatar: '👨‍💼'
            }
          },
          techFeatures: [
            {
              id: 1,
              icon: '❤️',
              title: '血管弹性调理',
              description: '通过量子技术改善血管弹性，增强血液循环功能。',
              benefits: ['改善弹性', '促进循环', '安全无创']
            },
            {
              id: 2,
              icon: '📊',
              title: '血压动态监测',
              description: '实时监测血压变化，为治疗方案调整提供数据支持。',
              benefits: ['实时监测', '数据分析', '预警提醒']
            },
            {
              id: 3,
              icon: '🎯',
              title: '个性化干预',
              description: '根据个体情况制定专属干预方案，确保精准有效。',
              benefits: ['量身定制', '精准干预', '效果显著']
            }
          ],
          lessons: [
            {
              id: 1,
              icon: '🎯',
              title: '综合干预效果更好',
              content: '高血压的管理需要综合干预，单纯依赖药物往往效果有限，结合生活方式调整才能取得理想效果。'
            },
            {
              id: 2,
              icon: '⏰',
              title: '坚持是成功的关键',
              content: '血压管理是一个长期过程，需要患者有足够的耐心和毅力，坚持健康的生活方式。'
            },
            {
              id: 3,
              icon: '🤝',
              title: '专业指导很重要',
              content: '专业的健康指导能够帮助患者少走弯路，科学有效地管理血压，避免盲目治疗。'
            }
          ]
        }
      },
      caseStudy: {},
        title: '慢性疲劳综合征患者的量子健康调理成功案例',
        category: '慢性病调理',
        date: '2024-03-15',
        client: '张女士',
        summary: '通过量子健康检测和个性化调理方案，成功帮助一位长期受慢性疲劳综合征困扰的患者恢复健康活力，重获生活质量。',
        tags: ['慢性疲劳', '量子调理', '个性化方案', '成功康复'],
        background: '张女士，42岁，企业高管，长期受慢性疲劳综合征困扰超过3年。主要症状包括持续性疲劳、睡眠质量差、注意力不集中、免疫力低下等。此前尝试过多种传统治疗方法，效果均不理想，严重影响了工作和生活质量。',
        stats: {
          age: '42岁',
          duration: '3年+',
          previous: '8种'
        },
        challenges: [
          {
            id: 1,
            icon: '😴',
            title: '严重睡眠障碍',
            description: '入睡困难，夜间易醒，睡眠质量极差，白天精神不振'
          },
          {
            id: 2,
            icon: '🔋',
            title: '持续性疲劳',
            description: '即使充分休息也无法缓解疲劳感，影响日常工作和生活'
          },
          {
            id: 3,
            icon: '🧠',
            title: '认知功能下降',
            description: '注意力不集中，记忆力减退，工作效率明显降低'
          },
          {
            id: 4,
            icon: '🛡️',
            title: '免疫力低下',
            description: '容易感冒，恢复缓慢，身体抵抗力明显下降'
          }
        ],
        solution: [
          {
            id: 1,
            step: '01',
            title: '量子健康检测',
            description: '采用先进的量子检测技术，全面评估患者的身体健康状况，包括细胞能量水平、神经系统功能、内分泌状态等关键指标。',
            duration: '2小时',
            method: '量子共振检测'
          },
          {
            id: 2,
            step: '02',
            title: '个性化方案制定',
            description: '基于检测结果，制定针对性的调理方案，包括营养补充、作息调整、运动指导、心理调节等综合措施。',
            duration: '1周',
            method: '多学科会诊'
          },
          {
            id: 3,
            step: '03',
            title: '量子能量调理',
            description: '运用量子能量调理技术，平衡身体能量场，激活细胞活力，促进身体自我修复能力。',
            duration: '8周',
            method: '量子能量场调理'
          },
          {
            id: 4,
            step: '04',
            title: '持续跟踪调整',
            description: '定期进行健康评估，根据身体变化及时调整调理方案，确保最佳效果。',
            duration: '持续进行',
            method: '动态监测'
          }
        ],
        implementation: [
          {
            id: 1,
            phase: '第一阶段',
            title: '基础调理期（1-2周）',
            description: '建立健康基础，改善睡眠质量，提升基础能量水平。',
            tasks: [
              '调整作息时间，建立规律睡眠',
              '营养补充，改善细胞营养状态',
              '基础能量调理，提升身体活力'
            ]
          },
          {
            id: 2,
            phase: '第二阶段',
            title: '深度调理期（3-6周）',
            description: '深入调理身体机能，修复受损系统，提升整体健康水平。',
            tasks: [
              '量子能量场深度调理',
              '内分泌系统平衡调节',
              '神经系统功能优化'
            ]
          },
          {
            id: 3,
            phase: '第三阶段',
            title: '巩固提升期（7-8周）',
            description: '巩固调理效果，建立健康生活方式，预防复发。',
            tasks: [
              '效果巩固调理',
              '健康生活方式指导',
              '长期健康管理计划制定'
            ]
          }
        ],
        results: {
          metrics: [
            {
              name: '睡眠质量',
              value: '92%',
              change: '+65%',
              changeType: 'positive'
            },
            {
              name: '精力水平',
              value: '88%',
              change: '+72%',
              changeType: 'positive'
            },
            {
              name: '工作效率',
              value: '85%',
              change: '+58%',
              changeType: 'positive'
            },
            {
              name: '免疫力',
              value: '90%',
              change: '+45%',
              changeType: 'positive'
            }
          ],
          chart: [
            { label: '调理前', height: 25 },
            { label: '2周', height: 40 },
            { label: '4周', height: 60 },
            { label: '6周', height: 75 },
            { label: '8周', height: 90 }
          ],
          testimonial: {
            quote: '量子健康调理彻底改变了我的生活。经过8周的专业调理，我不仅摆脱了长期困扰的疲劳问题，更重要的是重新找回了生活的热情和工作的动力。感谢和合网链的专业团队！',
            name: '张女士',
            title: '企业高管',
            avatar: '👩‍💼'
          }
        },
        techFeatures: [
          {
            id: 1,
            icon: '⚡',
            title: '量子能量检测',
            description: '利用量子共振原理，精准检测身体各系统的能量状态和功能水平。',
            benefits: ['无创检测', '精准度高', '全面评估']
          },
          {
            id: 2,
            icon: '🎯',
            title: '个性化方案',
            description: '根据检测结果和个人体质，制定针对性的健康调理方案。',
            benefits: ['量身定制', '科学配比', '动态调整']
          },
          {
            id: 3,
            icon: '🔄',
            title: '能量场调理',
            description: '通过量子能量场技术，平衡身体能量，激活自我修复能力。',
            benefits: ['深层调理', '根本改善', '持久效果']
          }
        ],
        lessons: [
          {
            id: 1,
            icon: '🎯',
            title: '精准诊断是关键',
            content: '传统的症状描述往往无法找到问题的根源，量子健康检测能够深入细胞层面，发现潜在的健康问题，为制定有效方案提供科学依据。'
          },
          {
            id: 2,
            icon: '⏰',
            title: '耐心等待效果',
            content: '慢性健康问题的形成需要时间，调理也需要过程。患者需要有足够的耐心，按照专业指导坚持调理，才能获得理想效果。'
          },
          {
            id: 3,
            icon: '🤝',
            title: '综合调理的重要性',
            content: '健康问题往往是多因素导致的，单一的调理方法效果有限。综合运用多种调理手段，才能达到最佳的治疗效果。'
          }
        ],
        relatedCases: [
          {
            id: 2,
            title: '失眠患者的量子健康改善案例',
            summary: '通过量子检测和个性化调理，成功改善长期失眠问题...',
            date: '2024-02-20',
            category: '睡眠改善',
            image: '😴'
          },
          {
            id: 3,
            title: '亚健康状态调理成功案例',
            summary: '运用量子健康技术，帮助亚健康人群恢复健康状态...',
            date: '2024-01-15',
            category: '亚健康调理',
            image: '💪'
          },
          {
            id: 4,
            title: '免疫力提升调理案例',
            summary: '通过量子能量调理，显著提升患者免疫力水平...',
            date: '2023-12-10',
            category: '免疫力提升',
            image: '🛡️'
          }
        ],
        consultationForm: {
          name: '',
          phone: '',
          email: '',
          issue: ''
        }
      }
  },
  mounted() {
    this.loadCase()
  },
  watch: {
    '$route.query.id'(e) {
      if(e){
        this.loadCase()
      }
    }
  },
  methods: {
    loadCase() {
      // 查看相关案例
      const caseId = this.$route.query.id
      this.caseStudy = this.allCases[caseId]
      console.log(caseId)
      console.log(this.allCases)
      if (!this.caseStudy) {
        // 不再强制跳转，而是显示错误信息或使用默认服务
        console.warn(`未找到ID为 ${caseId} 的服务，将显示默认服务`)
        // 使用第一个服务作为默认服务
        const serviceIds = Object.keys(this.allCases)
        if (serviceIds.length > 0) {
          this.caseStudy = this.allCases[serviceIds[0]]
          // 更新URL但不触发路由变化
          this.$router.replace({ query: { id: serviceIds[0] } })
        }
        return
      }
      
      // 获取相关服务
      this.relatedServices = Object.values(this.allCases)
        .filter(s => s.id !== parseInt(caseId))
        .slice(0, 3)
      this.currentCaseId = caseId;
    },
    viewCase(caseItem) {
      this.$router.push({
        path: '/case-detail',
        query: { id: caseItem.id }
      })
    },
    submitConsultation() {
      // 提交咨询表单
      console.log('提交咨询:', this.consultationForm)
      alert('咨询预约成功！我们的专家将尽快与您联系。')
      
      // 重置表单
      this.consultationForm = {
        name: '',
        phone: '',
        email: '',
        issue: ''
      }
    },
    // 预约提示点击
    reservationPromptClick() {
      alert('请拨打咨询热线：400-123-4567 或填写表单预约专家服务')
    },
    // 获取联系电话
    phone() {
      return '400-123-4567'
    }
  }
}
</script>

<style lang="scss" scoped>
/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

.navbar {
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  
  img {
    height: 40px;
    margin-right: 8px;
  }
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}

.breadcrumb {
  background: white;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}

.breadcrumb .container {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  padding-left: 10px;
  max-width: 100%;
}

.breadcrumb a {
  color: #666;
  text-decoration: none;
}

.breadcrumb a:hover {
  color: #1890ff;
}

.separator {
  color: #999;
}

.current {
  color: #1890ff;
}

/* 通用容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 案例内容 */
.case-content {
  padding: 3rem 0;
  background: white;
  min-height: 100vh;
}

/* 案例头部 */
.case-header {
  margin-bottom: 3rem;
}

.case-hero {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 3rem;
  align-items: center;
}

.case-image {
  height: 300px;
  background: linear-gradient(45deg, #1890FF, #40a9ff);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 6rem;
  box-shadow: 0 10px 30px rgba(24, 144, 255, 0.2);
}

.case-info h1 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 1rem;
  line-height: 1.3;
}

.case-meta {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.category {
  background: #1890FF;
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
}

.date, .client {
  color: #666;
  font-size: 0.9rem;
}

.case-summary {
  font-size: 1.2rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 1.5rem;
}

.case-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.tag {
  background: #f0f0f0;
  color: #666;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
}

/* 案例详情 */
.detail-section {
  margin-bottom: 4rem;
}

.detail-section h2 {
  color: #1890FF;
  font-size: 2rem;
  margin-bottom: 2rem;
  position: relative;
  padding-bottom: 0.5rem;
}

.detail-section h2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 3px;
  background: #1890FF;
}

.section-content {
  color: #333;
  line-height: 1.8;
}

/* 背景统计 */
.background-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 2rem;
}

.stat-item {
  text-align: center;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 10px;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  color: #1890FF;
  margin-bottom: 0.5rem;
}

.stat-label {
  color: #666;
  font-size: 0.9rem;
}

/* 挑战网格 */
.challenges-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.challenge-card {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  transition: transform 0.3s;
}

.challenge-card:hover {
  transform: translateY(-5px);
}

.challenge-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.challenge-card h3 {
  color: #333;
  margin-bottom: 1rem;
}

.challenge-card p {
  color: #666;
  line-height: 1.6;
}

/* 时间线 */
.solution-timeline {
  margin-top: 2rem;
}

.timeline-item {
  display: flex;
  gap: 2rem;
  margin-bottom: 3rem;
  align-items: flex-start;
}

.timeline-marker {
  width: 60px;
  height: 60px;
  background: #1890FF;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: bold;
  flex-shrink: 0;
}

.timeline-content {
  flex: 1;
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
}

.timeline-content h3 {
  color: #1890FF;
  margin-bottom: 1rem;
}

.timeline-details {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.duration, .method {
  background: #e6f7ff;
  color: #1890FF;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
}

/* 实施网格 */
.implementation-grid {
  display: grid;
  gap: 2rem;
  margin-top: 2rem;
}

.phase-card {
  background: #f8f9fa;
  border-radius: 10px;
  overflow: hidden;
}

.phase-header {
  background: #1890FF;
  color: white;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.phase-number {
  background: white;
  color: #1890FF;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: bold;
}

.phase-content {
  padding: 2rem;
}

.phase-tasks {
  margin-top: 1rem;
  padding-left: 1.5rem;
}

.phase-tasks li {
  margin-bottom: 0.5rem;
  color: #666;
}

/* 成果展示 */
.results-overview {
  margin-top: 2rem;
}

.result-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.metric-card {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
}

.metric-value {
  font-size: 3rem;
  font-weight: bold;
  color: #1890FF;
  margin-bottom: 0.5rem;
}

.metric-name {
  color: #333;
  margin-bottom: 0.5rem;
}

.metric-change {
  font-weight: bold;
}

.metric-change.positive {
  color: #52c41a;
}

.result-chart {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
  margin-bottom: 3rem;
}

.chart-placeholder {
  margin-top: 1rem;
}

.chart-bars {
  display: flex;
  justify-content: space-around;
  align-items: end;
  height: 200px;
}

.chart-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.bar {
  width: 40px;
  background: linear-gradient(to top, #1890FF, #40a9ff);
  border-radius: 5px 5px 0 0;
  transition: height 0.3s;
}

.bar-label {
  color: #666;
  font-size: 0.8rem;
}

/* 客户反馈 */
.client-testimonial {
  background: linear-gradient(135deg, #1890FF, #40a9ff);
  color: white;
  padding: 3rem;
  border-radius: 15px;
  position: relative;
}

.quote-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.client-testimonial blockquote {
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  font-style: italic;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.author-avatar {
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
}

.author-name {
  font-weight: bold;
  margin-bottom: 0.3rem;
}

.author-title {
  opacity: 0.8;
}

/* 技术特点 */
.tech-features {
  display: grid;
  gap: 2rem;
  margin-top: 2rem;
}

.tech-feature {
  display: flex;
  gap: 2rem;
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
}

.feature-icon {
  font-size: 3rem;
  flex-shrink: 0;
}

.feature-content h3 {
  color: #1890FF;
  margin-bottom: 1rem;
}

.feature-benefits {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-top: 1rem;
}

.benefit-tag {
  background: #e6f7ff;
  color: #1890FF;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
}

/* 经验总结 */
.lessons-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.lesson-card {
  background: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
}

.lesson-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.lesson-card h3 {
  color: #1890FF;
  margin-bottom: 1rem;
}

/* 相关案例 */
.related-cases {
  margin-bottom: 4rem;
}

.related-cases h2 {
  color: #1890FF;
  font-size: 2rem;
  margin-bottom: 2rem;
  text-align: center;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.case-card {
  background: white;
  border: 1px solid #eee;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;
}

.case-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.case-card-image {
  height: 150px;
  background: linear-gradient(45deg, #1890FF, #40a9ff);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
}

.case-card-content {
  padding: 1.5rem;
}

.case-card-content h3 {
  color: #333;
  margin-bottom: 0.5rem;
}

.case-summary {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 1rem;
}

.case-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  color: #999;
}

.case-category {
  background: #f0f0f0;
  color: #666;
  padding: 0.2rem 0.6rem;
  border-radius: 10px;
}

/* 咨询表单 */
.consultation-section {
  background: linear-gradient(135deg, #1890FF, #40a9ff);
  color: white;
  padding: 4rem 3rem;
  border-radius: 15px;
  margin-bottom: 3rem;
}

.consultation-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.consultation-content h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.consultation-content p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.consultation-form {
  background: white;
  color: #333;
  padding: 2rem;
  border-radius: 10px;
  text-align: left;
  box-sizing: border-box;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.form-group {
  margin-bottom: 1.5rem;
  box-sizing: border-box;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  font-family: inherit;
  transition: border-color 0.3s, box-shadow 0.3s;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1890FF;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.btn-submit {
  background: #1890FF;
  color: white;
  border: none;
  padding: 1rem 3rem;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 1rem;
  font-weight: 500;
  width: 100%;
}

.btn-submit:hover {
  background: #40a9ff;
  transform: translateY(-2px);
}

/* 底部 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
}

.footer-content {
  display: grid;
  grid-template-columns: 0.4fr 0.6fr;
  gap: 3rem;
  margin-bottom: 2rem;
}

.footer-links-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.footer-info h3 {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #fff;
}

.footer-info p {
  margin-bottom: 0.8rem;
  color: rgba(255, 255, 255, 0.8);
}

.contact-info {
  margin-top: 1rem;
}

.contact-info p {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
}

.footer-links, .footer-services, .footer-social {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-links h4, .footer-services h4, .footer-social h4 {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  color: #fff;
  position: relative;
}

.footer-links a, .footer-services a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
  display: block;
  padding: 0.2rem 0;
}

.footer-links a:hover, .footer-services a:hover {
  color: #fff;
}

.social-icon {
  display: block;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 0.2rem 0;
}

.social-icon:hover {
  color: #fff;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 2rem;
  text-align: center;
}

.copyright p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 1rem;
  }

  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
  }

  .case-hero {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .case-info h1 {
    font-size: 1.8rem;
  }

  .background-stats {
    grid-template-columns: 1fr;
  }

  .timeline-item {
    flex-direction: column;
    text-align: center;
  }

  .tech-feature {
    flex-direction: column;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .consultation-section {
    padding: 2rem 1rem;
  }

  .consultation-form {
    padding: 1.5rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-links-group {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>